import { TranslationService } from "@services/translation.service";
import * as angular from "angular";

import "./deleteConfirm.scss";

interface IDeleteConfirmComponentBindings {
    inlineConfirm: boolean;
    small: boolean;
    isDisabled: boolean;
    subjectName: string;
    subjectVerb: string;
    reference: string;
    onYes: () => void;
    onNo: () => void;
}

export class DeleteConfirmComponentController implements angular.IComponentController, IDeleteConfirmComponentBindings {
    inlineConfirm: boolean;
    small: boolean;
    isDisabled: boolean;
    subjectName: string;
    subjectVerb = this.translationService.t("Common.Delete");
    label: string;

    reference: string;

    onYes: () => void;
    onNo: () => void;

    showDeleteConfirm: boolean;

    static $inject = ["$mdDialog", "translationService"];

    constructor(
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly translationService: TranslationService
    ) {

    }

    onDeleteClick($event: MouseEvent) {
        if (this.inlineConfirm) {
            this.showDeleteConfirm = true;
        }
        else {
            this.showDeleteDialog($event);
        }
    }

    showDeleteDialog($event: MouseEvent) {
        const lowercaseSubjectVerb = (this.subjectVerb || "").toLowerCase();
        const dialog = this.$mdDialog
            .confirm()
            .multiple(true)
            .title(`${this.subjectVerb} ${this.subjectName}?`)
            .htmlContent(this.translationService.t('deleteConfirm.confirmMessage', [lowercaseSubjectVerb, (this.reference || this.translationService.t('deleteConfirm.this')), this.subjectName]))
            .targetEvent($event)
            .ok(this.subjectVerb)
            .cancel(this.translationService.t("Common.Cancel"));

        this.$mdDialog
            .show(dialog)
            .then(
                () => {
                    this.onYesClick();
                },
                () => {
                    this.onNoClick();
                });
    }

    onYesClick() {
        this.showDeleteConfirm = false;

        if (this.onYes) {
            this.onYes();
        }
    }

    onNoClick() {
        this.showDeleteConfirm = false;

        if (this.onNo) {
            this.onNo();
        }
    }
}

export class DeleteConfirmComponent implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {
        this.bindings = {
            inlineConfirm: "<?",
            small: "<?",
            isDisabled: "<?",

            subjectName: "@",
            subjectVerb: "@",
            reference: "@",
            label: "@",

            onYes: "&",
            onNo: "&"
        };

        this.controller = DeleteConfirmComponentController;
        this.template = require("./deleteConfirm.html");
    }
}
